import { useEffect, useState } from 'react';
import api from '../api';

export default function useAdminNavigation(enabled, pathname) {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    if (!enabled) { setCounts({}); return undefined; }
    let active = true, busy = false;
    const refresh = async () => {
      if (busy || document.hidden) return;
      busy = true;
      try {
        const response = await api.get('/api/crm/navigation', { timeout: 10000 });
        if (active) setCounts(response.data);
      } catch { if (active) setCounts({}); }
      finally { busy = false; }
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    document.addEventListener('visibilitychange', refresh);
    return () => { active = false; clearInterval(timer); document.removeEventListener('visibilitychange', refresh); };
  }, [enabled, pathname]);
  return counts;
}
